import axios from 'axios'
import _ from 'lodash'

//PATH VARIABLE REPLACER
function bindPath(url, pathVal) {
  var newUrl = url
  var pathExpression = /:[a-z0-9]+/gi
  var pathVar
  while (((pathVar = pathExpression.exec(url)), pathVar != null)) {
    let pathVarName = pathVar[0]
    newUrl = newUrl.replace(
      pathVarName,
      pathVal[pathVarName.substring(1, pathVarName.length)]
    )
  }
  return newUrl
}

// Local bind path
// function bindPath(url, pathVal) {
//   // Process path variables
//   var newUrl = url
//   var pathExpression = /:[a-z0-9]+/gi
//   var pathVar

//   while (((pathVar = pathExpression.exec(url)), pathVar != null)) {
//     let pathVarName = pathVar[0]
//     newUrl = newUrl.replace(
//       pathVarName,
//       pathVal[pathVarName.substring(1, pathVarName.length)]
//     )
//   }

//   // Replace only the prefix "http://192.168.2.132undefined"
//   if (newUrl.startsWith('http://localhostundefined')) {
//     newUrl = newUrl.replace(
//       'http://localhostundefined',
//       'http://localhost:50061'
//     )
//   }

//   return newUrl // Return the modified URL
// }

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  setupInterceptors: (store) => {
    axios.interceptors.request.use(
      function (config) {
        //CHECK REQUEST NEED TO ADD AUTH TOKEN IN THE HEADER
        if (config.headers.isAuthRequired) {
          // const token = `aTq+j5Pyk8PEoOAiDBZh9sbM3vBQk2YVgqibCHm55JbG8fy2UV2m34VFvhSkMOda6dwy9bZnEr/C4daBQeSkY6twHeJdwVd/Y0JN6vDZ5zB35Y5JiDeqGz7MxRjDm5sA+kag7pSiv9riTAhdGxT7P4ia289O/Jgs96ldLe0y7yMw/inFEMUNpYkTUnubV/ZPLEiOH9WvLKyNssO42QVv5TVtrQ9spcVuWywik2hM5qSjcL1UZQ3qwNkWaQL4micECJJXUOEhr7e9Sz0kkrCvyA==:bnJmeU1iWTdhVE44VzNxVw==`
          const token =
            typeof window !== 'undefined' ? localStorage.getItem('token') : null
          if (token) config.headers.Authorization = `Bearer ${token}` //ADD AUTHORIZATION HEADER
        }
        //DELETE CUSTOM PROPERTY IN THE REQUEST HEADERS
        delete config.headers.isAuthRequired
        delete config.headers.authKey

        //PATH VARIABLES IS AVAILABLE
        if (config.headers.path) {
          try {
            config.url = bindPath(config.url, config.headers.path)
          } catch (e) {
            console.log('ERROR OCCURED WHEN REPLACING PATH VARIABLES', e)
          }
        }

        return config
      },
      function (error) {
        return Promise.reject(error)
      }
    )

    // Add a response interceptor
    axios.interceptors.response.use(
      function (response) {
        return response
      },
      function (error) {
        //catches if the session ended!
        if (
          !axios.isCancel(error) &&
          (_.get(error, 'response.status', '') === 401 ||
            _.get(error, 'response.status', '') === 403)
        ) {
          if (_.get(error, 'response.data.more_info.is_access_denied')) {
            //access denied error
            window.location = '/403'
          } else {
            //session timeout error
            // localStorage.clear()
            // window.location = '/'
          }
        }
        return Promise.reject(error)
      }
    )
  },
}
